import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateGlobalState } from '../../store/actions';
import { pickPersistentState, getPersistentStoreKey } from '../../store/store-helpers';
import { useIntegrationName } from '../useIntegrationName';
export var useListener = function (eventName, onSignal, element, options) {
    if (element === void 0) { element = window; }
    if (options === void 0) { options = {}; }
    useEffect(function () {
        var handleSignal = function (e) {
            onSignal(e);
        };
        element.addEventListener(eventName, handleSignal, options);
        return function () { return element.removeEventListener(eventName, handleSignal, options); };
    }, [element, eventName, onSignal, options]);
};
export var useLocalStorageListener = function () {
    var integrationName = useIntegrationName();
    var storeKey = getPersistentStoreKey(integrationName);
    var stringifiedState = useSelector(function (state) { return JSON.stringify(pickPersistentState(state)); });
    var dispatch = useDispatch();
    // Listen to cart events from other tabs.
    // Chrome, firefox and edge do not trigger storage event for the same tab.
    useListener("storage", function (_a) {
        var key = _a.key, _b = _a.newValue, newValue = _b === void 0 ? "{}" : _b;
        // IE and Safari trigger storage event for update to localstorage from the same tab.
        if (document.hasFocus() || key !== storeKey)
            return;
        if (stringifiedState === newValue)
            return;
        // Update localstorage to the redux store.
        dispatch(updateGlobalState(JSON.parse(newValue)));
    });
};
